<template>
  <a-card :bordered="true" class="widget-1" :loading="loading">
    <a-statistic :title="title" :value="value" class="text-success">
      <template #prefix>
        <a-icon :type="icon" style="padding-right: 10px;" />
      </template>
    </a-statistic>
  </a-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {};
  },
};
</script>
